import React, { useState } from "react";
import ProgressDashboardViz from "./ProgressDashboardViz.component";
import { ProgressDashboardTableReport } from "./ProgressDashboardTableReport.component";

interface ProgressDashboardBaseProps {
    clientId: string | number;
    epochMonth: number | null;
}

const ProgressDashboardBase = ({ clientId, epochMonth }: ProgressDashboardBaseProps) => {
    const [view, setView] = useState<"viz" | "table">("viz");

    return (
        <div className="w-full h-full flex flex-col">
            <div className="flex justify-end mb-4 mr-4">
                <button
                    className={`px-4 py-2 rounded-l ${view === "viz" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700"}`}
                    onClick={() => setView("viz")}
                >
                    Visualization
                </button>
                <button
                    className={`px-4 py-2 rounded-r ${view === "table" ? "bg-blue-600 text-white" : "bg-gray-200 text-gray-700"}`}
                    onClick={() => setView("table")}
                >
                    Table/Export
                </button>
            </div>
            <div className="flex-1">
                {view === "viz" ? (
                    <ProgressDashboardViz clientId={clientId} epochMonth={epochMonth} />
                ) : (
                    <ProgressDashboardTableReport clientId={clientId} epochMonth={epochMonth} />
                )}
            </div>
        </div>
    );
};

export default ProgressDashboardBase;
